<template>
  <div>
    <div class="visually-hidden">
      <DatePicker
        v-model="model"
        updateModelType="date"
        :inputId="pickerInputId"
        @date-select="onDateSelect"
      />
    </div>

    <slot :open="open" :value="model" />
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';

const props = defineProps<{ modelValue: Date | undefined }>();
const emit = defineEmits<{
  (e: 'update:modelValue', value: Date | undefined): void;
  (e: 'blur'): void;
}>();

const model = ref(props.modelValue);

const pickerInputId = `datepicker-trigger-${crypto.randomUUID()}`;

function onDateSelect(date: Date) {
  model.value = date;
  emit('update:modelValue', date);
  emit('blur');
}

watch(
  () => props.modelValue,
  (val) => (model.value = val),
);

watch(model, (val) => emit('update:modelValue', val));

function open() {
  void nextTick(() => {
    const input = document.getElementById(pickerInputId);
    if (input instanceof HTMLInputElement) {
      input.focus();
    }
  });
}
</script>
<style scoped lang="css">
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>
